import { HTTP, authHeader } from './http-service';

class ComplaintSearchService {
  search(payload) {
    return HTTP.post(`/ComplaintSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/ComplaintSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new ComplaintSearchService();
